Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "PostById817865212",
  {"root":"PostById817865212--root","backButton":"PostById817865212--backButton"},
  "",
  8,
  "PostById817865212"
);

